import React from 'react';
import styles from "./Form.module.css";
import Tree from "./Tree.jsx";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ClearRounded from '@material-ui/icons/ClearRounded';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import {
    caption
} from '../../redux/actions/lang';


export default function FormTree( props ) {

    return (
        <div style={{ position: "relative", top: "-57px" }}>
            <Tooltip title = { caption.home } arrow>
            <IconButton
                color="primary"
                style={{ position: "relative", top: "5px", left: "7px", zIndex: "9000" }}
                onClick={ props.onStart }
            >
                <HomeRoundedIcon fontSize="large" className={ styles.xxIcon } />
            </IconButton>
            </Tooltip>
            
            <Tooltip title = { caption.close } arrow>
            <IconButton
                color="primary"
                style={{ position: "fixed", top: "45px", right: "55%", zIndex: "9000" }}
                onClick={ props.onCloseFormTree }
            >
                <ClearRounded fontSize="large" className={ styles.xxIcon } />
            </IconButton>
            </Tooltip>
            
            <input type="search" onChange={ props.onFind } style={{ width: "99%", height: "25px", outline: "none" }} />
            <p/>
            <Tree {...props} />
        </div>
    );
}
